import api from '@vue/services/api/session.api'
import { hasBearerToken, deleteBearerToken, hasExpiredToken } from '../../services/jwt.service';

const state = {
  token: window.localStorage.getItem('sessionToken') || null
}

const getters = {
  hasSession: (state) => !!state.token
};

const actions = {
  async init({ dispatch }) {
    if(hasBearerToken()) {
      try {
        await dispatch('createFromLegacyToken');
      }
      finally {
        deleteBearerToken();
      }
    } else {
      await dispatch('getToken');
    }
  },
  async getToken({ state, commit }) {
    if(state.token && !hasExpiredToken(state.token)) {
      return state.token;
    }

    try {
      const response = await api.getToken();
      commit('SET_TOKEN', response.data.token);
      window.localStorage.setItem('sessionToken', response.data.token);
      return state.token;
    }
    catch {
      return null;
    }
  },
  async create({ getters, commit }) {
    if(getters.hasSession) {
      return;
    }
    
    const response = await api.createSession();
    commit('SET_TOKEN', response.data.token);
    window.localStorage.setItem('sessionToken', response.data.token);
  },
  async createFromLegacyToken({ getters, commit }) {
    if(getters.hasSession) {
      return;
    }
    
    const response = await api.createFromLegacyToken();
    commit('SET_TOKEN', response.data.token);
    window.localStorage.setItem('sessionToken', response.data.token);
  },
  clearToken({ commit }) {
    commit('SET_TOKEN', null);
    window.localStorage.removeItem('sessionToken');
  }
};

const mutations = {
  ['SET_TOKEN'](state, token) {
    state.token = token;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
